import { IController } from 'angular';
import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { CurrentSchoolYear } from '../../../../../../../../ng2/shared/constants/current-school-year.constant';
import { GraduationPlan } from '../../../../../../../../ng2/shared/constants/graduation-plan.constant';
import { IWizardFilterActionsOptions } from '../../../../../components/wizard-filter-actions/wizard-filter-actions.typings';
import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class AssignIncompleteGradPlansStepCtrl implements IController {
  static $inject: string[] = ['$scope', 'ImSchool', 'ImStudentCreditGaps', 'WizardUtils'];

  private currentStudents: any[];
  public currentFilter: any;
  public currentLabel: string;
  public sort: object;
  public plurals: object;
  public buckets: any;
  public activeStudentsIds: string[];
  public activeStudentsWithIncompleteGradPlansIds: string[];
  public activeSuperSeniorsIds: string[];
  public activeSuperSeniorsWithIncompleteGradPlansIds: string[];
  public countActiveStudents: number;
  public countActiveStudentsWithIncompleteGradPlans: number;
  public countActiveSuperSeniors: number;
  public countActiveSuperSeniorsWithIncompleteGradPlans: number;
  public studentsToReview: string[];
  public countStudentsToReview: number;
  public columnKeys: string[];

  public options: IWizardFilterActionsOptions;

  constructor(
    public $scope,
    private ImSchool: ImSchool,
    private ImStudentCreditGaps: any,
    private WizardUtils: WizardUtils,
  ) {
    this.options = {
      columnKeys: ['gradPlan', 'creditMaxGaps', 'creditMaxGapsNoPlan'],
    };
  }

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.currentFilter = _.last(this.WizardUtils.getCurrentCohortFilter());
    this.currentStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.currentLabel = this.getLabel();

    this.buckets = this.generateFilteredStudentIdBuckets();

    this.activeStudentsIds = this.buckets.activeStudentsIds;
    this.activeStudentsWithIncompleteGradPlansIds = this.buckets.activeStudentsWithIncompleteGradPlansIds;
    this.activeSuperSeniorsIds = this.buckets.activeSuperSeniorsIds;
    this.activeSuperSeniorsWithIncompleteGradPlansIds = this.buckets.activeSuperSeniorsWithIncompleteGradPlansIds;

    this.countActiveStudents = this.activeStudentsIds.length;
    this.countActiveStudentsWithIncompleteGradPlans = this.activeStudentsWithIncompleteGradPlansIds.length;
    this.countActiveSuperSeniors = this.activeSuperSeniorsIds.length;
    this.countActiveSuperSeniorsWithIncompleteGradPlans = this.activeSuperSeniorsWithIncompleteGradPlansIds.length;

    this.studentsToReview = _.union(
      this.activeStudentsWithIncompleteGradPlansIds,
      this.activeSuperSeniorsWithIncompleteGradPlansIds,
    );
    this.countStudentsToReview = this.studentsToReview.length;

    this.sort = { sort: { colId: 'studentName', sort: 'asc' } };

    this.plurals = {
      student: {
        0: 'students',
        1: 'student',
        other: 'students',
      },
      studentMissing: {
        0: `are missing a planned diploma type and/or planned graduation date,
          or have a planned graduation date in the past.`,
        1: `is missing a planned diploma type and/or planned graduation date,
          or has a planned graduation date in the past.`,
        other: `are missing a planned diploma type and/or planned graduation date,
          or have a planned graduation date in the past.`,
      },
    };
  }

  public hasSuperSeniors(): boolean {
    return this.currentFilter && this.currentFilter === CurrentSchoolYear.ENDFULL;
  }

  private getLabel(): string {
    const status = this.hasSuperSeniors();
    return status === true ? `${this.currentFilter} and older` : this.currentFilter;
  }

  private generateFilteredStudentIdBuckets(): object {
    const activeStudentsIds = [];
    const activeStudentsWithIncompleteGradPlansIds = [];
    const activeSuperSeniorsIds = [];
    const activeSuperSeniorsWithIncompleteGradPlansIds = [];
    _.each(this.currentStudents, student => {
      const { isSuperSenior, studentId, gradPlan, cohort, status } = student;
      // If `All` is selected from dropdown, all students fall `inCohort`
      const inCohort = this.currentFilter ? cohort === this.currentFilter : true;
      const isActive = status === 'A';
      const gradPlanIsIncomplete = gradPlan === GraduationPlan.PLAN_INCOMPLETE.humanName;
      const gradPlanIsInPast = gradPlan === GraduationPlan.PLAN_IN_PAST.humanName;

      if (isActive && inCohort) activeStudentsIds.push(studentId);
      if (isActive && inCohort && (gradPlanIsIncomplete || gradPlanIsInPast)) {
        activeStudentsWithIncompleteGradPlansIds.push(studentId);
      }
      if (isActive && isSuperSenior) activeSuperSeniorsIds.push(studentId);
      if (isActive && isSuperSenior && (gradPlanIsIncomplete || gradPlanIsInPast)) {
        activeSuperSeniorsWithIncompleteGradPlansIds.push(studentId);
      }
    });

    return {
      activeStudentsIds,
      activeStudentsWithIncompleteGradPlansIds,
      activeSuperSeniorsIds,
      activeSuperSeniorsWithIncompleteGradPlansIds,
    };
  }
}
